import { useTranslation } from "../../hooks";
import classes from "../../styles/History.module.css";
import ExtraInfo from "./ExtraInfo";
import { getClasses, Currency, formatCurrency } from "../../utils";

const Wins: React.FC<{
  wins: any;
  extraInfo?: any;
  payout: number; // the full payout, i.e. the sum of all lines
  selectedWin: any;
  onHover: (index: number) => void;
  currency: Currency;
  spinIndex: number;
}> = ({ wins, extraInfo, payout, onHover, selectedWin, currency, spinIndex }) => {
  const activeLine = selectedWin?.id ?? -1;
  const linePayoutText = useTranslation("linepayout");
  const spinPayoutText = useTranslation("spinpayout");

  if (wins.length === 0) {
    return (
      <div className={classes.wins}>
        <div className={classes["win-label"]}>
          #<b>{spinIndex}</b> {" | "}
          <span>
            {spinPayoutText}: <b>{formatCurrency(payout ?? 0, currency)}</b>
          </span>
        </div>

        <ExtraInfo content={extraInfo}/>
      </div>
    );
  }

  return (
    <div className={classes.wins}>
      <div className={classes["win-label"]}>
        # <b>{spinIndex}</b> |{" "}
        <span>
          {spinPayoutText}: <b>{formatCurrency(payout, currency)}</b>
        </span>
        <span>
          {" | "}
          {linePayoutText}:{" "}
          <b>{formatCurrency(selectedWin.payout, currency)}</b>
        </span>
      </div>

      <ExtraInfo  content={extraInfo}/>

      <div className={classes["win-pills"]}>
        {wins
          .filter((w: any) => w.payout)
          .map((win: any, i: number) => {
            const activeClass = activeLine === win.id ? "active" : "";

            return (
              <div
                onMouseOver={onHover.bind(null, i)}
                key={`key-${i}`}
                className={getClasses(classes, "win-pill", activeClass)}
              >
                #{win.name}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default Wins;
